import React from 'react'

import img_me from '../images/Polymedia-Peter_van_der_Meer.jpg';


export default class extends React.Component {

  render() {
    document.title = "Contact | Peter van der Meer | INFLOW Online Marketing Bureau | Helpt jouw bedrijf groeien.";
    return (
      <div className="full big greyish">
        <div className="wrap content-block">

          <h2>Contact</h2>

          <div className="col-2" style={{margin:"0 auto", display:"block"}}>
            <div className="card more-rounded card">
              <a href="https://polymedia.nl" target="_blank" rel="noopener noreferrer"><h3 style={{margin:"0"}}>Polymedia</h3></a>
              <small style={{ margin: "0 0 1em", display:"block" }}>(INFLOW is een handelsnaam van Polymedia)</small>
              <p style={{ margin: "0" }}>Overvliet 21<br/>3545 NG Utrecht</p>
              <small style={{ margin: "0 0 1em", display:"block" }}>(Geen bezoekadres)</small>
              <p style={{ margin: "0 0 1em" }}><b>KvK</b> 78301629<br/><b>BTW</b> NL003318183B10</p>
              <p><img src={img_me} alt="Foto Peter van der Meer" className="testimonial-thumbnail" style={{borderColor:"#116cb2"}} /><a href="https://www.linkedin.com/in/peterdotplus/" target="_blank" rel="noopener noreferrer">LinkedIn Peter van der Meer</a>, Eigenaar bij INFLOW.</p>
              <p style={{ margin: "1em 0 1em" }}><b>Tel</b> 06 5756 7014<br /><b>E-mail</b> peter@ghostin.nl</p>
            </div>
          </div>

        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/Contact.js